import React, { useEffect } from 'react';
import { Grid, TextField, Checkbox, FormControlLabel } from '@mui/material';
import DialogBase from '../../commonComponents/DialogBaseV2';
import useLocales from '../../../hooks/useLocales';
import { EmailTemplateEditorModel } from '../../../common/Interfaces';
import { emailTemplateTypeIdToName } from '../../../common/constants';

export interface IdmEmailTemplateAddEditDialogProps {
    open: boolean;
    onClose: () => void;
    onSave: (emailTemplate: EmailTemplateEditorModel) => void;
    template: EmailTemplateEditorModel;
}

export function IdmEmailTemplateAddEditDialog(props: IdmEmailTemplateAddEditDialogProps): JSX.Element | null {
    const { template, onClose, onSave, open } = props;
    const { translate } = useLocales();
    const { templateType, defaultTemplate, contentPlaceholderKeyValuesListDefault, contentPlaceholderKeyValuesListCustom, template: customTemplate = '', isCustom, enabled } = template;
    const [isEnabled, setIsEnabled] = React.useState<boolean>(enabled ?? false);
    const [templateText, setTemplateText] = React.useState<string>(isCustom ? customTemplate : defaultTemplate);
    const [placeholders, setPlaceholders] = React.useState<Record<string, string>>(contentPlaceholderKeyValuesListDefault);

    const replaceContent = (html: string) => html.replace(/#([^#]+)#/g, (match, key) => placeholders[`#${key}#`] ?? match);
    const previewHtml = replaceContent(isEnabled ? templateText : defaultTemplate);
    const handleClose = () => onClose();
    const handleSave = () => { onSave({ ...template!, template: templateText, enabled: isEnabled, isCustom }); };
    const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => setIsEnabled(e.target.checked);

    useEffect(() => {
        setTemplateText(template.isCustom ? template.template ?? '' : template.defaultTemplate);
        setPlaceholders(template.isCustom ? template.contentPlaceholderKeyValuesListCustom ?? '' : template.contentPlaceholderKeyValuesListDefault);
    }, [template]);

    return (
        <DialogBase
            open={open}
            title={emailTemplateTypeIdToName(templateType)}
            onClose={handleClose}
            onSave={handleSave}
            size="xl"
            componentName="IDM Email Template"
        >
            <Grid container spacing={2}>
                <Grid item xs={6}>
                    <FormControlLabel
                        control={<Checkbox checked={isEnabled} onChange={handleCheckboxChange} />}
                        label={translate('IdmEmailTemplate.UseCustomTemplate')}
                    />
                    <TextField
                        label={translate('IdmEmailTemplate.Template')}
                        multiline
                        rows={20}
                        fullWidth
                        disabled={!isEnabled}
                        value={templateText}
                        onChange={(e) => setTemplateText(e.target.value)}
                        margin="normal"
                    />
                </Grid>

                <Grid item xs={6}>
                    <iframe
                        srcDoc={previewHtml}
                        key={previewHtml}
                        title={translate('IdmEmailTemplate.Preview')}
                        style={{ width: '100%', height: '600px', border: '1px solid #ddd' }}
                    />
                </Grid>
            </Grid>
        </DialogBase>
    );
}